module.exports = __webpack_public_path__ + "img/dylogo.9b76be3a.png";